import Swal from 'sweetalert2'

$('#noresults-contact').click(noResultModal);

// Show loading spinner
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        showLoader();
    }, 100);
    setTimeout(() => {
        hideLoader();
    }, 100)

    let scrollpos = localStorage.getItem('scrollpos');
    if (scrollpos) window.scrollTo({top: scrollpos});
});

window.onbeforeunload = function (e) {
    localStorage.setItem('scrollpos', window.scrollY);
};

async function noResultModal() {
    Swal.fire({
        title: _t('Contattaci'),
        icon: 'info',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: '#fc8b0b',
        allowOutsideClick: () => !Swal.isLoading(),
        width: '70vw',
        /*        customClass: {
                    container: 'no-result-contact-container',
                },*/
        html: `
                <form action="/api/forms/no-result" method="post" id="no-results-contact">
                    <div class="flex">
                        <div class="md_col-6 pr-10">
                            <input type="email" name="email" id="contact-email" class="swal2-input" placeholder="Email*" required>
                            <input type="text" name="marca" id="contact-marca" class="swal2-input" placeholder="${_t('Marca')}*" required>
                            <input type="text" name="modello" id="contact-modello" class="swal2-input" placeholder="${_t('Modello')}*" required>
                            <input type="text" name="anno" id="contact-anno" class="swal2-input" placeholder="${_t('Anno a partire da')}*" required>
                            <input type="text" name="ore_max" id="contact-ore" class="swal2-input" placeholder="${_t('Ore max')}*" required>

                            <div id="contact-allestimento-check" class="mb-10">
                                <h3 class="mb-10">${_t('Allestimento')} (${_t('opzionale')})</h3>
                                <label for="contact-allestimento-easy" class="swal2-checkbox">
                                    <input type="checkbox" name="allestimenti[]" id="contact-allestimento-easy" value="EASY">
                                    <span class="swal2-label">EASY</span>
                                </label>
                                <label for="contact-allestimento-premium" class="swal2-checkbox">
                                    <input type="checkbox" name="allestimenti[]" id="contact-allestimento-premium" value="PREMIUM">
                                    <span class="swal2-label">PREMIUM</span>
                                </label>
                                <label for="contact-allestimento-premium-plus" class="swal2-checkbox">
                                    <input type="checkbox" name="allestimenti[]" id="contact-allestimento-premium-plus" value="PREMIUM-PLUS">
                                    <span class="swal2-label">PREMIUM PLUS</span>
                                </label>
                                <label for="contact-allestimento-big-ready" class="swal2-checkbox">
                                    <input type="checkbox" name="allestimenti[]" id="contact-allestimento-big-ready" value="BIG-READY">
                                    <span class="swal2-label">BIG READY</span>
                                </label>
                            </div>
                        </div>
                        <div class="md_col-6 pl-10">
                            <input type="text" name="portata_min" id="contact-portata-min" class="swal2-input" placeholder="${_t('Portata min')} (KG)*">
                            <input type="text" name="portata_max" id="contact-portata-max" class="swal2-input" placeholder="${_t('Portata max')} (KG)*">
                            <input type="text" name="altezza_soll_min" id="contact-altezza-min" class="swal2-input" placeholder="${_t('Altezza sollevamento min')} (mm)*">
                            <input type="text" name="altezza_soll_max" id="contact-altezza-max" class="swal2-input" placeholder="${_t('Altezza sollevamento max')} (mm)*">
                            <input type="text" name="prezzo_max" id="contact-prezzo-max" class="swal2-input" placeholder="${_t('Prezzo max')} (€)*">

                            <div id="contact-foto-section">
                                <h3 class="mb-10">${_t('Foto (opzionale)')}</h3>
                                <input type="file" name="foto[]" multiple id="contact-foto" accept="image/*" >
                            </div>
                        </div>

                    </div>
                    <div id="contact-note-textarea" class="mb-10">
                        <h3 class="mb-5">${_t('Note (opzionale)')}</h3>
                        <textarea name="note" id="contact-note"></textarea>
                    </div>
                </form>
                    `,
        confirmButtonText: _t('Invia richiesta'),
        focusConfirm: false,
        preConfirm: () => {
            const contactForm = document.getElementById('no-results-contact');
            const formData = new FormData(contactForm);

            return fetch(contactForm.action, {
                method: contactForm.method,
                body: formData,
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    'Accept': 'application/json',
                },
            })
                .then(response => {
                    if (!response.ok && 422 !== response.status) {
                        throw new Error(response.statusText)
                    }

                    return response.json();
                })
                .then((result) => {
                    contactForm.querySelectorAll('input').forEach(function (el){
                       el.removeAttribute('style');
                    });

                    if (result.hasOwnProperty('errors')) {
                        for (let field in result.errors) {
                            contactForm.querySelector(`input[name="${field}"]`).setAttribute(
                                'style', 'border: 2px solid red'
                            );
                        }
                        Swal.showValidationMessage(
                            _t('Controllare campi evidenziati in rosso')
                        )
                    }
                })
                .catch(error => {
                    Swal.showValidationMessage(
                        `Errore: ${error}`
                    )

                })
        }
    }).then((result) => {
        if(! result.hasOwnProperty('dismiss')){
            Swal.fire(
                _t('Richiesta inviata'),
                _t('Sarà ricontattato al più presto'),
                'success'
            );
        }
    });
}

function hideLoader() {
    $('.new-ads').show();
    $('.loader-wrapper').hide();
}

function showLoader() {
    $('.new-ads').hide();
    $('.loader-wrapper').show();
}




// WEBPACK FOOTER //
// ./resources/js/site/_searchresult-page.js